import { render, staticRenderFns } from "./SelectItemClassesByUDG.vue?vue&type=template&id=4266a3d8"
import script from "./SelectItemClassesByUDG.vue?vue&type=script&lang=js"
export * from "./SelectItemClassesByUDG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports